import { IDynamicFormWidgetSection } from '@components/dynamic-form/types';
import { FormFieldType } from '@components/dynamic-form/types/inputTypes';
import { IAbstractRecord } from '@models';
import FormattingService from '@services/FormattingService';

export const getCancellationInputs = (
  lovs: Record<string, Record<string, string>>,
  values: IAbstractRecord,
  access: string
): IDynamicFormWidgetSection[] => [
  {
    inputs: {
      cancellationIssuanceDate: {
        name: 'cancellationIssuanceDate',
        title: 'Cancellation Issuance Date',
        type: FormFieldType.date,
        placeholder: 'Cancellation Issuance Date',
        value: values?.production_Amendment_createdOn || '',
        required: true,
        disabled: true,
      },
      cancellationEffectiveDate: {
        name: 'cancellationEffectiveDate',
        title: 'Cancellation Effective Date',
        placeholder: 'Cancellation Effective Date',
        type: FormFieldType.date,
        value:
          new Date(values?.production_Amendment_AmendmentEffectiveDate) || '',
        required: true,
        minDate:
          access === 'POS'
            ? new Date()
            : new Date(values?.policy_PolicyEffectiveDate),
        maxDate: new Date(values.policy_PolicyExpiryDate),
      },
      cancellationReason: {
        name: 'cancellationReason',
        title: 'Cancellation Reason',
        type: FormFieldType.select,
        placeholder: 'Cancellation Reason',
        value:
          FormattingService.toUpperSnakeCase(
            values?.production_Amendment_AmendmentReason
          ) || '',
        required: true,
        selectOptions: lovs?.cancellationReasons || {},
      },
    },
  },
];
